(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wob-collection"]) return;
  try {
    
const grid=document.getElementById('WatchGrid');
if(grid){const cards=Array.from(grid.querySelectorAll('.watch-card'));const reduced=()=>window.matchMedia('(prefers-reduced-motion: reduce)').matches;const change=fn=>{if(document.startViewTransition&&!reduced())document.startViewTransition(fn);else fn()};document.querySelectorAll('[data-filter]').forEach(button=>button.addEventListener('click',()=>change(()=>{document.querySelectorAll('[data-filter]').forEach(b=>b.setAttribute('aria-pressed',String(b===button)));let count=0;cards.forEach(card=>{card.hidden=button.dataset.filter!=='all'&&card.dataset.category!==button.dataset.filter&&card.dataset.brand!==button.dataset.filter;if(!card.hidden){count++;card.classList.add('is-visible')}});const empty=document.getElementById('FilterEmpty');if(empty)empty.hidden=count>0})));document.getElementById('CollectionSort')?.addEventListener('change',event=>change(()=>{const ordered=[...cards];if(event.target.value!=='featured')ordered.sort((a,b)=>event.target.value==='low'?Number(a.dataset.price)-Number(b.dataset.price):Number(b.dataset.price)-Number(a.dataset.price));ordered.forEach(card=>{card.classList.add('is-visible');grid.append(card)})}));}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wob-header"]) return;
  try {
    
const motionPreference=window.matchMedia('(prefers-reduced-motion: reduce)');
let revealObserver;
function initWobMotion(scope=document){if(motionPreference.matches||!('IntersectionObserver' in window))return;if(!revealObserver)revealObserver=new IntersectionObserver(entries=>entries.forEach(entry=>{if(entry.isIntersecting){entry.target.classList.add('is-visible');revealObserver.unobserve(entry.target)}}),{threshold:.08,rootMargin:'0px 0px 30px 0px'});scope.querySelectorAll('.watch-card,.section-top,.boutique-copy,.diamond-story-copy,.service-grid article,.enquiry>div').forEach((element,index)=>{if(element.classList.contains('reveal-ready'))return;element.style.setProperty('--reveal-delay',`${element.classList.contains('watch-card')?index%3*65:0}ms`);element.classList.add('reveal-ready');revealObserver.observe(element)})}
initWobMotion();document.addEventListener('shopify:section:load',event=>initWobMotion(event.target));document.addEventListener('focusin',event=>event.target.closest('.reveal-ready')?.classList.add('is-visible'));motionPreference.addEventListener('change',event=>{if(event.matches){revealObserver?.disconnect();document.querySelectorAll('.reveal-ready').forEach(element=>element.classList.add('is-visible'))}});

document.querySelectorAll('.mobile-menu a').forEach(link=>link.addEventListener('click',()=>{link.closest('details').removeAttribute('open')}));

  } catch(e) { console.error(e); }
})();
})();
